export const selectCareerPlan = state => state.careerPlan;
